// Adapter to normalize micaType values and avoid missing translations
export const getMicaTypeLabel = (micaType, translate) => {
  if (!micaType) return translate('UNKNOWN_MICA') // optional fallback

  switch (micaType) {
    // Other valid micaTypes
    case 'MICA_WELL':
    case 'MICA_PLUS':
    case 'MICA':
    case 'MICA_LITE':
    case 'MICA_MINI':
    case 'DESK':
      return translate(micaType)

    default:
      return micaType // safe fallback to raw value
  }
}
